<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        Server List
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Server List</a>
        </li>
      </ul>
    </div>
    <router-view @refresh="refresh()"></router-view>
    <!-- <template slot="header">
      <i class='fa fa-align-justify'></i> Server List
      <b-button v-if="only_select != true" class="float-right" variant='success' @click="Download">Download</b-button>
    </template> -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">Registration Date</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            ~
          </b-form-group>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">Usage Mode</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-form-radio-group id="radio-group-2" v-model="so.opt.mode" v-b-tooltip.hover title="Please enter the Usage Mode you want to search for">
              <b-form-radio value="2" @click="so.sv=`mode`"><b-badge variant="danger">Block Mode</b-badge></b-form-radio>
              <b-form-radio value="1" @click="so.sv=`mode`"><b-badge variant="warning">Detect Mode</b-badge></b-form-radio>
              <b-form-radio value="0" @click="so.sv=`mode`"><b-badge varinat="secondary">Off</b-badge></b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">Nickname</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group label-for="ph_code" v-b-tooltip.hover title="Please enter the nickname you want to search for">
            <b-form-input v-model="so.sv" @click="so.sk='nickname';"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-4">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh" > Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="so.adv = false"> Cancel </b-button>
        </b-form-group>
      </b-row>
    </b-card>

    <div class="d-flex flex-wrap align-items-center">
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1"  @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">Search</option>
              <option value="group.groupname">Group</option>
              <option value="nickname">Nickname</option>
              <option value="ip_addr">Server</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input v-model="so.sv" class="form-control col-xl-12"  @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="so.adv = !so.adv">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" v-model="filter_is_del">Only Alive</b-checkbox>
          </div>
          <div class="mb7" sm="4" v-if="only_select">
            <b-button size="sm" variant="primary" @click="multi_all"> Select All </b-button>
            <b-button size="sm" variant="warning" @click="multi_clear"> Clear </b-button>
          </div>
          <div class="mb7" sm="4" v-else>
            <select class="form-control" v-model="so.perPage" @change="refresh">
              <option value="15">Show Count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table
            class="table table_add table-striped"
            :tbody-tr-class="rowClass"
            ref="_wc_agent_list"
            responsive="sm"
            striped hover small fixed
            :items="getItems"
            :fields="fields"
            :current-page="so.currentPage"
            empty-text="not found"
            :per-page="so.perPage"
            v-show="show"
            :sortBy="so.sk"
            @row-clicked="multi_click"
            style="cursor:pointer;"
            >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>
            <template slot="id" slot-scope="row">
              {{only_select != true ? startRow - row.index : ''}}
              <b-form-checkbox :disabled="agent_id == row.item.id" v-if="only_select" v-model="row.item.check" @change="multi_one($event, row)"></b-form-checkbox>
            </template>
            <!-- <template slot="is_alive" slot-scope="row">
              <b-badge variant="success" v-if="pong.list.indexOf(row.item.id) > -1">Online</b-badge>
              <b-badge v-else variant="secondary">Offline</b-badge>
            </template> -->
            <template slot="group" slot-scope="row">
              <del v-if="row.item.is_del">{{ row.item.group.groupname ? row.item.group.groupname : '-' }}</del>
              <span v-else>{{ row.item.group.groupname ? row.item.group.groupname : '-' }}</span>
            </template>
            <template slot="mode" slot-scope="row">
              <!-- <b-badge @click="modal_multi = true" v-if="row.item.manage_id && row.item.manage_id > 0" variant="dark">Multiplexing(?)</b-badge> -->
              <b-badge v-if="row.item.mode == 0" variant="secondary">Off</b-badge>
              <b-badge v-else-if="row.item.mode == 1" variant="warning">Detect</b-badge>
              <b-badge v-else-if="row.item.mode == 2" variant="danger">On</b-badge>
              <b-badge v-else variant="dark">None</b-badge>
            </template>
            <template slot="server" slot-scope="row">
              <span v-if="!row.item.ip_addr && !row.item.version">-</span>
              <span v-else>{{row.item.ip_addr}}({{row.item.version}})</span>
            </template>
            <template slot="nickname" slot-scope="row">
              <!-- <b-button variant="info" class="pull-right" size="sm" @click="update_nickname = row.item; nickname_modify_modal = true;">Modify</b-button> -->
              <del v-if="row.item.is_del">{{row.item.nickname ? row.item.nickname : '-'}}</del>
              <span v-else>{{row.item.nickname ? row.item.nickname :'-'}}</span>
            </template>
            <template slot="domain" slot-scope="row">
              <span @click="modal_domain = true; modal_domain_info = row.item.policy" style="cursor:pointer" v-if="row.item.policy && row.item.policy.domains && row.item.policy.domains.length > 0">
                <b-badge v-if="mode_count(row.item, { mode : 'DetectionOnly' }) > 0" variant="warning">Detect : {{mode_count(row.item, { mode : 'DetectionOnly' })}}</b-badge>
                <b-badge v-if="mode_count(row.item, { mode : 'On' }) > 0" variant="danger">Block : {{mode_count(row.item, { mode : 'On' })}}</b-badge>
                <b-badge v-if="mode_count(row.item, { mode : 'On' }) + mode_count(row.item, { mode : 'DetectionOnly' }) < 1" variant="dark">Off</b-badge>
                <b-button v-if="row.item.policy.domains.length > 1" size="sm" variant="add">?</b-button>
              </span>
              <span v-else>-</span>
            </template>
            <!-- <template slot="select" slot-scope="row">
              <b-button size="sm" @click="detail(row.item)" >Check</b-button>
              <b-button size="sm" v-if="row.item.is_alive" @click="modal_del = true; del_info = row.item" variant="danger">Remove</b-button>
            </template> -->
          </b-table>
         </div>
      </div>
    </div>
    <template v-if="!show">
      <b-card>
        <tr>
          <th>No server installed</th>
        </tr>
      </b-card>
    </template>
    <b-row class="mt30">
      <b-col class="pagination justify-content-center">
        <b-pagination size="sm" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
      </b-col>
    </b-row>
    <!-- <b-modal title="NickNama Modify" v-model="nickname_modify_modal" @ok="nickname_modify()" header-bg-variant="info">
      <p> You can change the nickname of the server. </p>
      <p> Please enter a nickname to change.  </p>
      <p> <b> * Check Server Name </b> </p>
      <p> Origin Server Nickname : {{update_nickname.nickname}}  </p>
      <b-form-input v-model="modify_nickname" placeholder="Please enter a nickname to change."></b-form-input>
    </b-modal> -->
    <!-- <b-modal title="Delete"  class="modal-danger" v-model="modal_del" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> Agent deletion from the server does not automatically delete it Server recommends deleting first  </p>
      <p> If deleted, the firewall will not be processed.  </p>
      <p> <b> * Check Server Name </b> </p>
      <p> Delete Server Nickname : {{del_info.nickname}}  </p>
      <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
    </b-modal> -->
    <b-modal title="Usage Domain" v-model="modal_domain" @ok="modal_domain = false" ok-only ok-variant="outline-primary">
      <b-table striped hover small fixed class="table-responsive-sm" :items="modal_domain_info.domains" :fields="domain_manage_fields" empty-text="not found">
        <template slot="domain" slot-scope="row">{{row.item.domain}} <b-badge v-if="row.item.temp" variant="danger">Un Saved</b-badge></template>
        <template slot="mode" slot-scope="row">
          <b-badge v-if="row.item.mode == 'Off'" variant="secondary">Off</b-badge>
          <b-badge v-else-if="row.item.mode == 'DetectionOnly'" variant="warning">Detect</b-badge>
          <b-badge v-else-if="row.item.mode == 'On'" variant="danger">Block</b-badge>
          <b-badge v-else>None</b-badge>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
      </b-table>
    </b-modal>
    <!-- <b-modal title="Using Multiplexing" v-model="modal_multi" @ok="modal_multi = false" header-bg-variant="warning" ok-only>
      <h5>Managed by a multiplexed firewall policy</h5>
    </b-modal> -->
  <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
